import React from "react";

export const CubeIcon: React.FC<{ className?: string }> = ({ className }) => {
	return (
		<svg
			width="12"
			height="12"
			viewBox="0 0 17 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M16.4696 4.36776L8.9896 0.129554C8.83948 0.0445521 8.67112 0 8.5 0C8.32888 0 8.16052 0.0445521 8.0104 0.129554L0.5304 4.36776C0.369936 4.45862 0.236034 4.59246 0.142719 4.75527C0.0494043 4.91808 0.000110099 5.10386 0 5.29316V13.7062C0.000110099 13.8955 0.0494043 14.0813 0.142719 14.2441C0.236034 14.4069 0.369936 14.5408 0.5304 14.6316L8.0104 18.8698C8.16039 18.9552 8.32881 19 8.5 19C8.67119 19 8.83961 18.9552 8.9896 18.8698L16.4696 14.6316C16.6301 14.5408 16.764 14.4069 16.8573 14.2441C16.9506 14.0813 16.9999 13.8955 17 13.7062V5.29316C16.9999 5.10386 16.9506 4.91808 16.8573 4.75527C16.764 4.59246 16.6301 4.45862 16.4696 4.36776ZM8.3368 0.747076C8.38669 0.718264 8.44287 0.703139 8.5 0.703139C8.55713 0.703139 8.61331 0.718264 8.6632 0.747076L16.0369 4.92546L8.5 9.19357L0.96305 4.92546L8.3368 0.747076ZM0.8568 14.015C0.80327 13.9847 0.758609 13.94 0.727501 13.8857C0.696393 13.8314 0.679986 13.7694 0.68 13.7062V5.56673L8.16 9.80317V18.152L0.8568 14.015ZM16.1432 14.015L8.84 18.1494V9.80317L16.32 5.56673V13.7062C16.3199 13.7692 16.3034 13.831 16.2723 13.8852C16.2412 13.9393 16.1966 13.9839 16.1432 14.0141V14.015Z"
				fill="currentColor"
				stroke="currentColor"
				strokeWidth="0.5"
			/>
		</svg>
	);
};
